export default "__VITE_ASSET__44585666__"